var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8029_2923)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8029_2923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8029_2923)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8029_2923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8029_2923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.3726 18.6274 0 12 0C5.3726 0 0 5.3726 0 12C0 18.6274 5.3726 24 12 24Z",
    fill: "url(#paint0_linear_8029_2923)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5415 6.16675C10.0583 6.16675 9.6665 6.5585 9.6665 7.04175V7.62508C9.6665 8.10833 10.0583 8.50008 10.5415 8.50008H13.4582C13.9414 8.50008 14.3332 8.10833 14.3332 7.62508V7.04175C14.3332 6.5585 13.9414 6.16675 13.4582 6.16675H10.5415Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.26256 7.84492C7.59465 7.51283 8.05789 7.3959 8.79167 7.35474V7.62504C8.79167 8.59154 9.57517 9.37504 10.5417 9.37504H13.4583C14.4249 9.37504 15.2083 8.59154 15.2083 7.62504V7.35474C15.9421 7.3959 16.4053 7.51283 16.7374 7.84492C17.25 8.35749 17.25 9.18244 17.25 10.8324V14.3324C17.25 15.9823 17.25 16.8072 16.7374 17.3198C16.2248 17.8324 15.3999 17.8324 13.75 17.8324H10.25C8.60008 17.8324 7.77513 17.8324 7.26256 17.3198C6.75 16.8072 6.75 15.9823 6.75 14.3324V10.8324C6.75 9.18244 6.75 8.35749 7.26256 7.84492ZM12 12.8397L10.851 11.6907C10.6802 11.5198 10.4032 11.5198 10.2323 11.6907C10.0615 11.8616 10.0615 12.1385 10.2323 12.3094L11.3813 13.4584L10.2323 14.6074C10.0615 14.7782 10.0615 15.0552 10.2323 15.2261C10.4032 15.3969 10.6802 15.3969 10.8511 15.2261L12 14.0771L13.1489 15.2261C13.3198 15.3969 13.5968 15.3969 13.7677 15.2261C13.9385 15.0552 13.9385 14.7782 13.7677 14.6074L12.6187 13.4584L13.7677 12.3094C13.9385 12.1386 13.9385 11.8616 13.7677 11.6907C13.5968 11.5198 13.3198 11.5198 13.149 11.6907L12 12.8397Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8029_2923",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8029_2923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearClipboard);
export default __webpack_public_path__ + "static/media/ClearClipboard.0e1f04aa58801ffe63fa8c151cac65b0.svg";
export { ForwardRef as ReactComponent };